/**
 * Nepalese rupee.
 */
export var NPR = {
  code: 'NPR',
  base: 10,
  exponent: 2
};